'use client';

import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from '@chakra-ui/react';
import { motion, MotionProps } from 'framer-motion';

export type ButtonProps = ChakraButtonProps &
  MotionProps & {
    isInteractivityHighlightEnabled?: boolean;
  };

export const Button = (props: ButtonProps) => {
  const {
    children,
    isLoading,
    isDisabled,
    isInteractivityHighlightEnabled = true,
    ...rest
  } = props;

  const getActivityAnimations = (): ButtonProps => {
    if (isLoading || isDisabled || !isInteractivityHighlightEnabled) return {};

    return {
      whileHover: { scale: 1.05 },
      whileTap: { scale: 0.95 },
    };
  };

  return (
    <ChakraButton
      as={motion.button}
      {...getActivityAnimations()}
      isLoading={isLoading}
      isDisabled={isDisabled}
      {...rest}
    >
      {children}
    </ChakraButton>
  );
};
